import { usePayseraLoginPollLazyQuery } from 'api/core/generated';
import {
  APP_POLLING_INTERVALS,
  AppApiVersions,
  LocalStorageKeys,
} from 'app-constants';
import { getFromStorage } from 'services';

export const usePayseraLoginPoll = () => {
  const [
    pollPayseraLoginStatus,
    {
      data: payseraLoginStatusData,
      loading: payseraLoginStatusLoading,
      error: payseraLoginStatusError,
      stopPolling,
    },
  ] = usePayseraLoginPollLazyQuery({
    context: { apiVersion: AppApiVersions.core },
    pollInterval: APP_POLLING_INTERVALS.default,
  });

  const startPayseraLoginStatusPolling = () => {
    const session_id = getFromStorage(LocalStorageKeys.sessionId) ?? '';
    return pollPayseraLoginStatus({ variables: { session_id } });
  };

  return {
    payseraLoginStatus: payseraLoginStatusData?.status,
    payseraLoginStatusLoading,
    payseraLoginStatusError,
    startPayseraLoginStatusPolling,
    stopPayseraLoginStatusPolling: stopPolling,
  };
};
